import { PhAuthLogoutComponent } from './ph-auth-logout.component';
import { AUTH_FLOW_PATH_LOGOUT } from './ph-auth-routes';

export const AUTH_FLOW_LOGOUT_ROUTES = [
  { path: AUTH_FLOW_PATH_LOGOUT, component: PhAuthLogoutComponent },
];
